import { IAddressApiCreatePayload, Shipment } from '@packlink/packlink-sdk';
import { ICheckoutState } from '@store/reducers/checkout';
import { IServiceState, UpsellType } from '@types';

const build = (
    selectedUpsells: UpsellType[],
    checkoutState: ICheckoutState,
    service: IServiceState,
    dropoffPointId: string | null,
    from: IAddressApiCreatePayload,
    coverage: number,
    to: IAddressApiCreatePayload,
    secondHand: boolean,
): Shipment => {
    const interval = checkoutState.collection?.interval ? checkoutState.collection?.interval.match(/(.*)-(.*)/) : null;

    return Shipment.deserialize({
        additionalData: {
            parcelIds: [],
        },
        ...(!service.dropOff &&
            checkoutState.collection && {
                collection: {
                    date: checkoutState.collection?.date?.format('YYYY/MM/DD'),
                    interval: { start: interval?.[1], end: interval?.[2] },
                },
            }),
        content: {
            description: checkoutState.content?.type,
            secondHand,
            value: checkoutState.content?.value,
        },
        dropoffPointId: dropoffPointId || undefined,
        from: {
            alpha2Code: from.country || undefined,
            city: from.city || undefined,
            state: from.state || undefined,
            zipCode: from.zip_code || undefined,
            company: from.company || undefined,
            email: from.email || undefined,
            firstName: from.name || undefined,
            lastName: from.surname || undefined,
            phone: from.phone || undefined,
            street1: from.street1 || undefined,
            street2: from.street2 || undefined,
        },
        service: {
            carrierName: service.carrier,
            name: service.name,
            id: parseInt(service.id, 10),
        },
        parcels: checkoutState.packages ? [checkoutState.packages] : [],
        packlinkReference: checkoutState.reference || undefined,
        shipmentCustomReference: checkoutState.customReference || undefined,
        to: {
            alpha2Code: to.country || undefined,
            city: to.city || undefined,
            state: to.state || undefined,
            zipCode: to.zip_code || undefined,
            company: to.company || undefined,
            email: to.email || undefined,
            firstName: to.name || undefined,
            lastName: to.surname || undefined,
            phone: to.phone || undefined,
            street1: to.street1 || undefined,
            street2: to.street2 || undefined,
        },
        upsales: {
            adultSignature: { available: selectedUpsells.includes(UpsellType.ADULT_SIGNATURE) },
            printInStore: { available: selectedUpsells.includes(UpsellType.PRINT_IN_STORE) },
            proofOfDelivery: { available: selectedUpsells.includes(UpsellType.PROOF_OF_DELIVERY) },
            insurance: {
                available: selectedUpsells.includes(UpsellType.ENHANCED),
                amount: coverage,
            },
        },
    });
};

const OrdersRequestBodyBuilder = {
    build,
};

export default OrdersRequestBodyBuilder;
